import React from 'react';
import styles from '../style.module.scss';
import { useDispatch } from 'react-redux';
import { actions } from '@Redux/detail/Itineraries';

interface I_Props {
    isWhole: boolean;
    setIsWhole: (isWhole: boolean) => void;
}

const ModeBtn: React.FC<I_Props> = ({ isWhole, setIsWhole }) => {
    const dispatch = useDispatch();

    return (
        <div className={styles.modeBtn}>
            <div
                onClick={() => {
                    setIsWhole(true);
                    dispatch(actions.setIsReduceMode(false));
                }}
                style={isWhole ? { color: '#f03742' } : { color: '#222' }}
            >
                完整行程
            </div>
            <div
                onClick={() => {
                    setIsWhole(false);
                    dispatch(actions.setIsReduceMode(true));
                }}
                style={isWhole ? { color: '#222' } : { color: '#f03742' }}
            >
                精簡行程
            </div>
        </div>
    );
};

export default ModeBtn;
